import React from 'react';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { InsuringAgreementsFormValues } from '../../modals/InsuringAgreementsModal';
import { InsuringAgreementsModalConfig } from '../../modals/InsuringAgreementsModal';
import type { InsuringAgreements } from '../../../../../../api/types/rater-x-preset';

const AmendInsuringAgreement = (props: AmendatoryLineItemProps) => {
  const handleAddInsuringAgreement = (
    formValues: InsuringAgreementsFormValues
  ) => {
    const _agreements = formatInsuringAgreementsForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: {
          agreements: {
            values: _agreements as unknown as InsuringAgreements[],
          },
        },
      },
    });
  };

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(InsuringAgreementsModalConfig, {
          data: {
            onSubmit: handleAddInsuringAgreement,
            agreements: getDefaultInsuringAgreementValues(
              props.value?.props?.agreements?.values as InsuringAgreements[]
            ),
          },
        })}
      >
        Add/Edit ({String(props.value?.props?.agreements?.values?.length ?? 0)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default AmendInsuringAgreement;

export function getDefaultInsuringAgreementValues(
  values: InsuringAgreements[] | undefined
) {
  if (!values) {
    return [];
  }

  return values.map((value) => {
    return {
      date: value.props.date.value ?? '',
      paragraph: value.props.paragraph?.value ?? '',
    };
  });
}

export function formatInsuringAgreementsForState(
  formValues: InsuringAgreementsFormValues
) {
  return formValues.agreements.map((agreement) => {
    return {
      props: Object.keys(agreement).reduce((acc, key) => {
        const value = agreement[key as keyof typeof agreement];
        return {
          ...acc,
          [key]: { value },
        };
      }, {} as InsuringAgreements),
    };
  });
}
